<template>
    <div class="container">
        <HomeHeader />
        <ReportHeader />
        <BgContainer>
            <main>
                <div class="page_title_row">
                    <PageTitle :title="modular.tagName || '文章详情'" :isBack="true" />
                    <span class="alias">{{ modular.tagAlias || "DETAILS" }}</span>
                </div>
                <div class="content_center">
                    <div class="content_box">
                        <div class="tit_row">
                            <h1 v-html="article.articleTitle" id="article_title"></h1>
                            <div class="info_coll">
                                <div class="row">
                                    <div class="info">
                                        <span class="date">{{ article.showTime }}</span>
                                        <span class="date" v-if="article.newsType">{{ article.newsType }}</span>
                                        <span class="date" v-if="article.sourceType">{{ article.sourceType }}</span>
                                        <span class="date" v-if="article.country">{{ article.country }}</span>
                                        <span class="date" v-for="item in article?.tips">{{ item }}</span>
                                    </div>
                                    <div class="operate">
                                        <!-- 应急处理建议 -->
                                        <el-tooltip class="box-item" effect="dark" content="应急处理建议" placement="bottom" v-if="!isShare">
                                            <div class="coll" @click="$router.push('/suggest')">
                                                <i class="iconfont icon-yuezhangdan" style="font-size: 22px"></i>
                                            </div>
                                        </el-tooltip>
                                        <!-- 风险等级 -->
                                        <RiskChange :artcle="article" v-if="article.risk && !isShare" @change="(e) => emits('setArticle')">
                                            <div class="coll" :class="article.risk">
                                                <span v-if="article.risk === 'high'">高</span>
                                                <span v-if="article.risk === 'middle'">中</span>
                                                <span v-if="article.risk === 'low'">低</span>
                                            </div>
                                        </RiskChange>
                                        <!-- 翻译 -->
                                        <el-tooltip class="box-item" effect="dark" content="翻译为中文" placement="bottom" v-if="article.isEnglish">
                                            <div class="coll" v-if="!isTranslate" @click="handleTranslate('chinese_simplified')">
                                                <i class="iconfont icon-zhongwenxianshi"></i>
                                            </div>
                                            <div class="coll active" v-else @click="handleTranslateReset">
                                                <i class="iconfont icon-zhongwenxianshi"></i>
                                            </div>
                                        </el-tooltip>
                                        <!-- 原文链接 -->
                                        <el-tooltip class="box-item" effect="dark" content="原文链接" placement="bottom" v-if="article.articleLink && article.articleSource !== '微信' && !isShare">
                                            <div class="coll" v-if="article.articleLink && article.articleSource !== '微信'" @click="openSource">
                                                <i class="iconfont icon-lianjie"></i>
                                            </div>
                                        </el-tooltip>
                                        <!-- 收藏 -->
                                        <el-tooltip class="box-item" effect="dark" content="收藏" placement="bottom" v-if="!isShare">
                                            <div class="coll" v-if="!article.favoriteId" @click="openC({ ...article, tagId: $route.query.tagId1 })">
                                                <i class="iconfont icon-shoucang1"></i>
                                            </div>
                                            <div class="coll active" v-else @click="openCancel(article)">
                                                <i class="iconfont icon-shoucang"></i>
                                            </div>
                                        </el-tooltip>
                                        <!-- 分享 -->
                                        <el-tooltip class="box-item" effect="dark" content="分享" placement="bottom" v-if="!isShare">
                                            <div class="coll share" @click="openShare(article)">
                                                <i class="iconfont icon-fenxiang"></i>
                                            </div>
                                        </el-tooltip>
                                        <!-- 发送报告 -->
                                        <el-tooltip class="box-item" effect="dark" content="发送报告" placement="bottom" v-if="!isShare">
                                            <div class="coll share" @click="openSend">
                                                <i class="iconfont icon-fasongyoujian"></i>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="user" @click="openSource">
                                        <div class="header_img">
                                            <img :src="article.releaseAvatar" alt="" v-if="article.releaseAvatar" />
                                            <p v-else>{{ article?.releaseName?.slice(0, 1) || "-" }}</p>
                                        </div>
                                        <p>{{ article.articleSource }} {{ article.releaseName !== article.articleSource ? `| ${article.releaseName}` : `` }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="content" id="artcle_content" v-html="article.articleContent"></div>
                        <!-- 返回上一页 -->
                        <div class="back_pre_page" v-if="!isArt">
                            <BackPrePage />
                        </div>
                        <div class="translate" v-if="isTranslate">
                            <p>翻译内容仅供参考，请以英文版本为准。</p>
                        </div>
                    </div>
                    <!-- 上下一页 -->
                    <div class="page_box" v-if="!keywordId && (prevNext.preData?.articleId || prevNext.nextData?.articleId)">
                        <div class="li" v-if="prevNext.preData?.articleId" @click="onPrevNext(prevNext.preData?.articleId, 'prePage')">
                            <h2>上一篇</h2>
                            <h3>{{ prevNext.preData?.articleTitle }}</h3>
                        </div>
                        <div class="li" v-if="prevNext.nextData?.articleId" @click="onPrevNext(prevNext.nextData?.articleId, 'nextPage')">
                            <h2>下一篇</h2>
                            <h3>{{ prevNext.nextData?.articleTitle }}</h3>
                        </div>
                    </div>
                    <!-- 关联文章 -->
                    <div class="related_box" v-if="keywordId && relatedArticles.length">
                        <h1>相关文章</h1>
                        <ul>
                            <li v-for="item in relatedArticles" :key="item.articleId" @click="onRelated(item)">
                                <p>{{ item.articleTitle }}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </main>
        </BgContainer>
    </div>
    <!-- 收藏 -->
    <CollectionDialog :show="showC" :art="art" @close="closeC" @success="emits('setArticle')" />
    <!-- 分享文章 -->
    <ShareDetailsDialog :show="showShare" :row="rowShare" @close="closeShare" />
    <!-- 取消收藏 -->
    <CancelCollDialog :show="showCancel" :row="rowCancel" @close="closeCancel" @success="handleCancelSuccess" />
    <!-- 发送报告 -->
    <SendDialog :show="showSend" :groupDict="groupDict" :articleIdList="[articleId]" @close="closeSend" />
</template>

<script setup>
import { computed, ref } from "vue";
import ReportHeader from "@/components/customer-week-report/pc/ReportHeader.vue";
import BgContainer from "@/components/customer-week-report/pc/BgContainer.vue";
import PageTitle from "@/components/customer-week-report/pc/PageTitle.vue";
import { useRoute } from "vue-router";
import ShowYear from "@/components/customer-week-report/pc/ShowYear.vue";
import ShowMonth from "@/components/customer-week-report/pc/ShowMonth.vue";
import BackPrePage from "@/components/customer-week-report/pc/BackPrePage.vue";
import HomeHeader from "@/components/common/HomeHeader.vue";
import CollectionDialog from "@/components/collection-dialog/index.vue";
import useCollection from "@/components/collection-dialog/useCollection";
import ShareDetailsDialog from "@/components/share-dialog/details/index.vue";
import useShareDetails from "@/components/share-dialog/details/useShareDetails";
import CancelCollDialog from "@/components/cancel-coll-dialog/index.vue";
import useCancelColl from "@/components/cancel-coll-dialog/useCancelColl";
import useTranslate from "./useTranslate";
import { openWindow } from "@/utils";
import RiskChange from "@/components/common/RiskChange.vue";
import SendDialog from "./send-dialog/index.vue";
import useSend from "./send-dialog/useSend";
import useDict from "./useDict";

const $route = useRoute();
const props = defineProps({
    articleId: { type: [String, Number], default: "" },
    article: { type: Object, default: {} },
    prevNext: { type: Object, default: {} },
    modular: { type: Object, default: {} },
    relatedArticles: { type: Array, default: [] },
    yearMonth: { type: Object, default: {} },
    isShare: { type: Boolean, default: false },
    isArt: { type: Boolean, default: false },
});
const emits = defineEmits(["onPrevNext", "onRelated", "setArticle"]);
const keywordId = computed(() => $route.query.keywordId); // 关键词id

function onPrevNext(id, type) {
    emits("onPrevNext", { id, type });
}

function onRelated(e) {
    emits("onRelated", e);
}

// 收藏
const { show: showC, open: openC, close: closeC, art } = useCollection();

// 取消收藏
const {
    show: showCancel,
    open: openCancel,
    close: closeCancel,
    row: rowCancel,
    handleCancelSuccess,
} = useCancelColl(() => {
    emits("setArticle");
});

// 跳转原文链接
function openSource() {
    if (!props.article.articleLink) return;
    if (props.article.articleSource === "微信") return;
    openWindow(props.article.articleLink);
}

// 分享
const { show: showShare, row: rowShare, open: openShare, close: closeShare } = useShareDetails();

// 翻译
const { handleTranslate, handleTranslateReset, isTranslate } = useTranslate(props);

// 发送报告
const { show: showSend, open: openSend, close: closeSend } = useSend();

// 字典
const { groupDict } = useDict({ props });
</script>

<style lang="scss" scoped>
.container {
    background-color: #e6e6e6;
    min-height: calc(100vh - var(--home-header-height));
    padding-top: var(--home-header-height);

    .show_date {
        border-top: 1px solid var(--week-primary-color);
        position: absolute;
        top: 60px;
        right: 44px;
        padding-top: 30px;
        padding-right: 100px;
        padding-left: 10px;
        display: flex;
        align-items: center;
    }

    .small_logo {
        position: absolute;
        top: 87px;
        right: 52px;
    }

    main {
        width: 100%;
        min-height: calc(100vh - var(--week-pc-header-height));
        background-color: #f5f5f5;
        box-shadow: 0 0 20px #ccc;
        padding: 46px 80px;

        .page_title_row {
            margin-bottom: 29px;

            .alias {
                display: block;
                color: var(--week-primary-color);
                font-size: 14px;
                font-weight: bold;
                margin-left: 25px;
                margin-top: 7px;
                line-height: 1em;
            }
        }

        .content_center {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .content_box {
                flex-grow: 1;
                min-width: 0;
                background-color: #fff;
                box-shadow: 2.7px 7.5px 8.19px 0.81px rgba(0, 0, 0, 0.06);
                position: relative;
                padding-bottom: 50px;

                .tit_row {
                    padding: 50px;
                    padding-bottom: 0;

                    h1 {
                        font-size: 18px;
                        color: #000;
                    }
                    .info_coll {
                        margin-top: 30px;
                        .row {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-bottom: 6px;
                            .info {
                                display: flex;
                                flex-wrap: wrap;

                                .date {
                                    color: #999b9f;
                                    font-size: 12px;
                                    padding-right: 12px;
                                }
                            }

                            .user {
                                display: flex;
                                align-items: center;
                                cursor: pointer;

                                .header_img {
                                    width: 22px;
                                    height: 22px;
                                    overflow: hidden;
                                    border-radius: 50%;
                                    margin-right: 8px;
                                    text-align: center;
                                    background-color: #f2f2f2;

                                    img {
                                        width: inherit;
                                        height: inherit;
                                        border-radius: 50%;
                                        object-fit: cover;
                                    }

                                    p {
                                        background-color: var(--week-primary-color);
                                        line-height: 22px;
                                        font-size: 12px;
                                        color: #fff;
                                    }
                                }

                                p {
                                    color: #070a16;
                                    font-size: 16px;
                                    font-weight: bold;
                                    line-height: 22px;
                                }
                            }

                            .keys {
                                display: flex;
                                justify-content: flex-end;
                                .keys_item {
                                    margin-left: 8px;
                                    background-color: #f7f7f7;
                                    height: 40px;
                                    padding: 0 8px;
                                    border-radius: 8px;
                                    display: flex;
                                    align-items: center;
                                    color: #666;
                                    font-size: 14px;
                                }
                            }
                            .operate {
                                display: flex;
                                .coll {
                                    width: 40px;
                                    height: 40px;
                                    background-color: #f7f7f7;
                                    border-radius: 8px;
                                    cursor: pointer;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    margin-left: 8px;
                                    .iconfont {
                                        font-size: 20px;
                                        color: #979797;
                                    }
                                    &.active {
                                        background-color: #fff3ec;
                                        .iconfont {
                                            color: var(--primary-color);
                                        }
                                    }
                                    &.high {
                                        background-color: #f20505;
                                        color: #fff;
                                    }
                                    &.middle {
                                        background-color: #ff8000;
                                        color: #fff;
                                    }
                                    &.low {
                                        background-color: #43cf7c;
                                        color: #fff;
                                    }
                                }
                            }
                        }
                    }
                }

                .content {
                    padding: 0 50px;
                    padding-top: 35px;
                    overflow-x: hidden;

                    :deep(*) {
                        max-width: 100%;
                        line-height: 2em;
                    }
                }

                .back_pre_page {
                    position: fixed;
                    right: 0;
                    bottom: 16px;
                    display: flex;
                    justify-content: flex-end;
                }
                .translate {
                    padding: 0 50px;
                    padding-top: 30px;
                    display: flex;
                    align-items: center;
                    .coll {
                        width: 40px;
                        height: 40px;
                        background-color: #f7f7f7;
                        border-radius: 8px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .iconfont {
                            font-size: 20px;
                            color: #979797;
                        }
                        &.active {
                            background-color: #fff3ec;
                            .iconfont {
                                color: var(--primary-color);
                            }
                        }
                    }
                    p {
                        font-size: 12px;
                        color: #666;
                    }
                }
            }

            .page_box {
                width: 226px;
                margin-left: 28px;
                flex-shrink: 0;

                .li {
                    background-color: #fff;
                    padding: 22px;
                    padding-top: 25px;
                    padding-bottom: 39px;
                    cursor: pointer;
                    box-shadow: 2.7px 7.5px 8.19px 0.81px rgba(0, 0, 0, 0.06);

                    &:first-child {
                        margin-bottom: 18px;
                    }

                    h2 {
                        font-size: 18px;
                        color: #000;
                        padding-bottom: 20px;
                    }

                    h3 {
                        font-size: 14px;
                        color: #000;
                        overflow: hidden;
                    }
                }
            }

            .related_box {
                width: 226px;
                margin-left: 28px;
                flex-shrink: 0;

                h1 {
                    font-size: 18px;
                    color: #000;
                    padding-bottom: 20px;
                }

                ul {
                    li {
                        background-color: #fff;
                        box-shadow: 2.7px 7.5px 8.19px 0.81px rgba(0, 0, 0, 0.06);
                        width: 100%;
                        cursor: pointer;
                        font-size: 14px;
                        font-weight: bold;
                        padding: 38px 22px;
                        margin-bottom: 20px;
                        overflow: hidden;

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }
    }
}
</style>
